import { connect } from 'react-redux';
import { IReduxState, TThunkDispatch } from '../../types/redux';
import { setMortgageRealtyPrice } from '../../actions/mortgage';
import { FilterAmountInput, IFilterAmountInputProps } from '../../components/FilterAmountInput';

type TFilterMortgageRealtyPriceStateProps = Pick<
  IFilterAmountInputProps,
  'integerLimit' | 'placeholder' | 'suffix' | 'value'
>;
type TFilterMortgageRealtyPriceDispatchProps = Pick<IFilterAmountInputProps, 'onValueChange'>;

export function mapStateToProps(state: IReduxState): TFilterMortgageRealtyPriceStateProps {
  return {
    integerLimit: 12,
    placeholder: 'Стоимость недвижимости',
    suffix: `\u20BD`,
    value: state.mortgage.filterRealtyPrice,
  };
}

export function mapDispatchToProps(dispatch: TThunkDispatch): TFilterMortgageRealtyPriceDispatchProps {
  return {
    onValueChange: (value: number) => dispatch(setMortgageRealtyPrice(value)),
  };
}

export const FilterMortgageRealtyPriceContainer = connect(mapStateToProps, mapDispatchToProps)(FilterAmountInput);
